import i18n from "@/i18n";

const formatTypeahead = {
    users(user = {}) {
        return {
            _id: user._id,
            firstname: user.firstname,
            lastname: user.lastname,
            fullname: user.fullname,
            name: user.firstname + " " + user.lastname,
            desc: (user.teamRole && user.teamRole.title) || "",
            picture: user.picture,
        };
    },
    tags(tag = {}) {
        return {
            _id: tag._id,
            name: tag.name,
        };
    },
    jiraIssues(issue = {}) {
        return {
            ...issue,
            _id: issue.ley,
            name: `${issue.key}: ${issue.summaryText}`,
        };
    },
    skills(skill = {}) {
        return {
            _id: skill._id,
            name: skill.name,
            desc:
                skill.type === "team"
                    ? i18n.t(`goals.update.labelCompanySkill`)
                    : skill.type === "localTeam"
                    ? i18n.t(`goals.update.labelTeamSkill`)
                    : "",
        };
    },
};

export default formatTypeahead;
